import delegate from 'delegate';

export default class translatePopupController {
    constructor() {
        this.explainPopup = null;

        if (document.querySelector('.translateExplainPanel')) {
            this.init();
        }
    }

    init() {
        this.explainPopup = document.querySelector('.translateExplainPanel');

        this.setEventListeners();
        this.explainPopup.removeAttribute("style");
    }

    setEventListeners() {
        // Opening
        if (document.querySelector('.headerMenu .translateExplain')) {
            document.querySelector('.headerMenu .translateExplain').addEventListener('click', () => {
                if (document.querySelector('body > header').classList.contains('explainPopupActive')) {
                    this.hidePopup();
                } else {
                    this.showPopup();
                }
            });
        }

        // Closing
        this.explainPopup.querySelectorAll('.closeButton').forEach(closeButton => {
            closeButton.addEventListener('click', e => {
                this.hidePopup();
            })
        });

        this.explainPopup.querySelectorAll('.closeTranslateExplain').forEach(button => {
            button.addEventListener('click', e => {
                this.hidePopup();
            });
        });

        document.addEventListener('keydown', e => {
			if (e.key.toLowerCase().substr(0, 3) == 'esc') {
                this.hidePopup();
            }
        });

        this.explainPopup.addEventListener('click', e => {
            // Should only trigger if clicked outside the panel
            if (e.target.contains(this.explainPopup.querySelector('.panelWrapper'))) {
                this.hidePopup();
            }
        });

    }

    showPopup() {
        document.querySelector('body > header').classList.add('explainPopupActive');
        this.explainPopup.classList.add('active');
        
        this.explainPopup.setAttribute('aria-expanded', true);
        this.explainPopup.setAttribute('aria-hidden', false);
        
        document.documentElement.classList.add('blurSearch');
        document.documentElement.classList.add('disableScroll');

        // Enable tabbing on all items
        this.explainPopup.querySelectorAll('a, button, input').forEach(clickable => {
            clickable.setAttribute('tabindex', '0');
            clickable.setAttribute('aria-hidden', 'false');
        });
    }

    hidePopup() {
        document.querySelector('body > header').classList.remove('explainPopupActive');
        this.explainPopup.classList.remove('active');

        this.explainPopup.setAttribute('aria-expanded', false);
        this.explainPopup.setAttribute('aria-hidden', true);

        document.documentElement.classList.remove('blurSearch');
        document.documentElement.classList.remove('disableScroll');

        // Disable tabbing on all items
        this.explainPopup.querySelectorAll('a, button, input').forEach(clickable => {
            clickable.setAttribute('tabindex', '-1');
            clickable.setAttribute('aria-hidden', 'true');
        });
    }
}